import script from "./AssistantList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssistantList.vue?vue&type=script&setup=true&lang=ts"

import "./AssistantList.vue?vue&type=style&index=0&id=6177a9ce&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6177a9ce"]])

export default __exports__